(function () {
  var TARGET_EMAIL = 'buildabotlabs@gmail.com';

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('file-request-overlay');
    var modal = document.getElementById('file-request-modal');
    var closeBtn = document.getElementById('file-request-close');
    var form = document.getElementById('FileRequestForm');
    var fileInput = document.getElementById('FRFile');
    var emailInput = document.getElementById('FREmail');
    var messageInput = document.getElementById('FRMessage');
    var note = document.getElementById('FRNote');

    if (!overlay || !modal || !form) return;

    function openModal() {
      overlay.classList.add('is-open');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-open-file-request]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    overlay.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var file = fileInput.files[0];
      var fileName = file ? file.name : '';
      var replyEmail = emailInput.value.trim();
      var message = messageInput.value.trim();

      var subject = '3D Print File Request - ' + (fileName || 'attached file');
      var bodyLines = [
        'Reply-to email: ' + replyEmail,
        '',
        'Message:',
        message || '(none)',
        '',
        'File to attach: ' + (fileName || '(please attach the file you selected)')
      ];

      var mailtoUrl =
        'mailto:' + TARGET_EMAIL +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(bodyLines.join('\n'));

      if (note) {
        note.textContent = fileName
          ? 'Opening your email app - please attach "' + fileName + '" before sending.'
          : 'Opening your email app - please attach your file before sending.';
      }

      window.location.href = mailtoUrl;
    });
  });
})();
